import { render, staticRenderFns } from "./viewHotNews.vue?vue&type=template&id=48696954&"
import script from "./viewHotNews.vue?vue&type=script&lang=js&"
export * from "./viewHotNews.vue?vue&type=script&lang=js&"
import style0 from "./viewHotNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports